module.exports = __webpack_public_path__ + "img/3-2.d8d86136.png";